import React from 'react';
import "./databasecloud.scss";

//images
import imgDatabasecloud from "../../../assets/connectors/DatabaseCloud.png";
import { t } from 'i18next';
const DatabaseCloud = () => {
    return (
        <div className="container-database">
            <div className="img-database">
                <img src={imgDatabasecloud} alt="" />
            </div>
            <div className="texts-database">
                <h1>{t("connectors.cloud_connectors.title")}</h1>
                <p>{t("connectors.cloud_connectors.section_text")}</p>
                {/* <button id="btn-database">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default DatabaseCloud